import { render, staticRenderFns } from "./ItemProducts.vue?vue&type=template&id=3b2a859a&"
import script from "./ItemProducts.vue?vue&type=script&lang=js&"
export * from "./ItemProducts.vue?vue&type=script&lang=js&"
import style0 from "./ItemProducts.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports